// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.searchWrap {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: var(--size-400);
  align-items: flex-end;
}
.searchWrap .search-bar {
  max-width: 260px;
}

.version-status-active {
  color: var(--alert-success);
}
.version-status-inactive {
  color: var(--disabled-font-color);
}

.active-flag {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--size-400);
}
.active-flag .custom-checkbox {
  cursor: pointer;
  max-width: 160px;
}
.active-flag .custom-checkbox:hover {
  background-color: var(--white-bg-hover);
}
.active-flag .custom-checkbox .checkbox-content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}
.active-flag .custom-checkbox .checkbox-content-wrapper .label-text {
  font-weight: bold;
}
.active-flag .custom-checkbox .checkbox-content-wrapper i {
  padding: var(--size-200);
  font-size: var(--size-500);
}
.active-flag .custom-checkbox .k-checkbox {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  margin: 0;
  padding: 0;
  pointer-events: none;
}

.actions {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--size-500);
}
@media (min-width: 768px) {
  .actions {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}`, "",{"version":3,"sources":["webpack://./src/app/cp/system-config/mobile-release-versions/mobile-release-versions.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,qBAAA;AACJ;AAAI;EACI,gBAAA;AAER;;AAEI;EACI,2BAAA;AACR;AACI;EACI,iCAAA;AACR;;AAGA;EACI,aAAA;EACA,0BAAA;EACA,oBAAA;AAAJ;AAEI;EACI,eAAA;EACA,gBAAA;AAAR;AACQ;EACI,uCAAA;AACZ;AACQ;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;AACZ;AAAY;EACI,iBAAA;AAEhB;AAAY;EACI,wBAAA;EACA,0BAAA;AAEhB;AACQ;EACI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,oBAAA;AACZ;;AAIA;EACI,aAAA;EACA,0BAAA;EACA,oBAAA;AADJ;AAEI;EAJJ;IAKQ,gDAAA;EACN;AACF","sourcesContent":[".searchWrap {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    gap: var(--size-400);\n    align-items: flex-end;\n    .search-bar {\n        max-width: 260px;\n    }\n}\n.version-status {\n    &-active {\n        color: var(--alert-success);\n    }\n    &-inactive {\n        color: var(--disabled-font-color);\n    }\n}\n\n.active-flag {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: var(--size-400);\n\n    .custom-checkbox {\n        cursor: pointer;\n        max-width: 160px;\n        &:hover {\n            background-color: var(--white-bg-hover);\n        }\n        .checkbox-content-wrapper {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            gap: 8px;\n            .label-text{\n                font-weight: bold;\n            }\n            i {\n                padding: var(--size-200);\n                font-size: var(--size-500);\n            }\n        }\n        .k-checkbox {\n            position: absolute;\n            opacity: 0;\n            width: 0;\n            height: 0;\n            margin: 0;\n            padding: 0;\n            pointer-events: none;\n        }\n    }\n}\n\n.actions{\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: var(--size-500);\n    @media (min-width: 768px) {\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
